export type TenderStatus = 'Published' | 'Expired' | 'ToBePublished';

export const TENDER_STATUS_COLORS: Record<TenderStatus, string> = {
  Published: '#466eb1',
  Expired: '#6b7280',
  ToBePublished: '#eab308',
};
